import AddDiscoveryPlaceImages from './AddDiscoveryPlaceImages.container';

export default AddDiscoveryPlaceImages;
